import { getBlog, updateBlogAPI } from "./blogAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  blog: {},
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchBlog = createAsyncThunk("blog/fetchBlog", async (id) => {
  const blog = await getBlog(id);
  return blog;
});

export const updateBlog = createAsyncThunk("blog/updateBlog", async ({ id, updatedFields }) => {
  const blog = await updateBlogAPI(id, updatedFields);
  return blog;
});


const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const pendingReducer = (state) => {
      state.isError = false;
      state.isLoading = true;
    };
    const fulfilledReducer = (state, action) => {
      state.isLoading = false;
      state.blog = action.payload;
    };
    const rejectedReducer = (state, action) => {
      state.isLoading = false;
      state.blog = {};
      state.isError = true;
      state.error = action.error?.message;
    };

    builder
      .addCase(fetchBlog.pending, pendingReducer)
      .addCase(fetchBlog.fulfilled, fulfilledReducer)
      .addCase(fetchBlog.rejected, rejectedReducer)
      .addCase(updateBlog.pending, pendingReducer)
      .addCase(updateBlog.fulfilled, fulfilledReducer)
      .addCase(updateBlog.rejected, rejectedReducer);
  },
});

export default blogSlice.reducer;
